'use client';

import { GoogleOAuthProvider } from '@react-oauth/google';
import { Switch, Route } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';

import { Path } from 'components/_hooks/use-router';
import { useAppInit } from './_mediator/app-init/use-app-init';

import { TooltipPortal } from 'components/UI/tooltip/tooltip-portal';
import { ProjectDeletionsModal } from 'components/app/app-components/project-deletions-modal/project-deletions-modal';
import { TitleCreditsModal } from 'components/app/app-components/title-credits/title-credits-modal';
import { TitleCreditsGenerator } from 'components/app/app-components/title-credits/title-credits-generator';
import { StoryConfig } from 'components/app/app-components/story-config/story-config';
import { AppContainer } from 'components/app/app-container/app-container';
import { AppLayout } from 'components/app/app-layout/app-layout';
import { AppCrash } from 'components/app/app-crash/app-crash';
import { Projects } from 'components/app/projects/projects';
import { Welcome } from 'components/app/welcome/welcome';
import { PP } from 'components/app/playground/player/pp';
import { Intro } from 'components/app/intro/intro';
import { Tutorials } from 'components/app/intro-tutorials/tutorials';
import { PaymentFcModal } from './app-components/payment/payment-fc.tsx';
import { PaymentSubsModal } from './app-components/payment/payment-subs.tsx';
import { MonitorRejectionToast } from './app-components/monitor-rejection-toast/monitor-rejection-toast.tsx';

export const App = () => {
  const errorBoundaryCb = useAppInit();

  return (
    <ErrorBoundary FallbackComponent={AppCrash} onError={errorBoundaryCb}>
      <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
        <AppContainer>
          <Switch>
            <Route exact path={Path.pulseIntro} component={Welcome} />
            <Route exact path={Path.projects} component={Projects} />
            <Route exact path={Path.playerPlayground} component={PP} />
            <Route path={Path.app} component={AppLayout} />
            <Route path="*" component={AppLayout} />
          </Switch>
          <Intro />
          <Tutorials />
          <StoryConfig />
          <TooltipPortal />
          <TitleCreditsModal />
          <TitleCreditsGenerator />
          <ProjectDeletionsModal />
          <MonitorRejectionToast />
        </AppContainer>
        <PaymentFcModal />
        <PaymentSubsModal />
      </GoogleOAuthProvider>
    </ErrorBoundary>
  );
};
